





























import { Component, Vue, Inject, Ref, Watch } from 'vue-property-decorator';

import ServizioList from './ServizioList.vue';
import { CrudService } from '@/data/services/crud.service';
import ServizioFilter from './ServizioFilter.vue';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { ServiceInstance } from '@/data/models/serviceinstance.model';
import ServizioDetail from './servizio/ServizioDetail.vue';
import ServizioDelete from './servizio/ServizioDelete.vue';
import { ServiceInstanceService } from '@/data/services/serviceinstance.service';

@Component({
	components: {
		ServizioList,
		ServizioFilter
	},
})
export default class Servizi extends Vue {
	@Inject('CrudService') crudService!: CrudService<ServiceInstance>;
	@Inject('ServiceInstanceService') serviceinstanceService!: ServiceInstanceService;

	@Ref('list') list!: ServizioList;
	@Ref('filter') filter!: ServizioFilter;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	@Watch('state.headquarter', { deep: true })
	onHQChange() {
		this.filter.search();
	}

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.load();
	}

	deleteServizio(item: ServiceInstance) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-servizio-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(ServiceInstance, 'serviceinstance', item)
					.then(() => {
						this.list.load();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}

}
